import { find, replace, startsWith, uniqBy } from 'lodash';
import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { useApolloClient, useMutation } from 'react-apollo';
import { useLocation } from 'react-router-dom';
import dataIdFromObject from '../../../app/dataIdFromObject';
import useUserPreferences from '../../data/hooks/useUserPreferences';
import updateLastUserRouteMutation from '../../data/updateLastUserRoute.graphql';
import { getModules } from '../../data/withModules/useModules';
const TrackUserHistory = ({ children }) => {
    const location = useLocation();
    const { me, accessList, preferences } = useUserPreferences();
    const client = useApolloClient();
    const modules = useMemo(() => getModules({
        me,
        accessList,
    }), [accessList, me]);
    const [updateLastUserRoute] = useMutation(updateLastUserRouteMutation);
    const lastLocation = useRef(location.pathname);
    const saveRoute = useCallback((pathname) => {
        const module = find(modules, ({ route }) => startsWith(pathname, `/${route}`));
        updateLastUserRoute({
            variables: {
                route: pathname,
                module: module === null || module === void 0 ? void 0 : module.id,
            },
        });
        if (module === null || module === void 0 ? void 0 : module.id) {
            const LAST_PATHNAME_MODULES = uniqBy([
                {
                    __typename: 'LastPathnameModules',
                    route: replace(pathname, '/', ''),
                    module: module.id,
                },
                ...(preferences.LAST_PATHNAME_MODULES || []),
            ], 'module');
            client.writeData({
                id: dataIdFromObject(preferences) || undefined,
                data: {
                    ...preferences,
                    LAST_PATHNAME_MODULES,
                },
            });
            sessionStorage.setItem('TAB_LAST_PATHNAME', LAST_PATHNAME_MODULES[0].route);
        }
    }, [client, preferences, modules, updateLastUserRoute]);
    useEffect(() => {
        const tabLastPathname = sessionStorage.getItem('TAB_LAST_PATHNAME');
        if ((me === null || me === void 0 ? void 0 : me.id) && lastLocation.current !== location.pathname) {
            lastLocation.current = location.pathname;
            saveRoute(location.pathname);
        }
        if ((me === null || me === void 0 ? void 0 : me.id) && !tabLastPathname) {
            saveRoute(location.pathname);
        }
    }, [saveRoute, me, location]);
    return <>{children}</>;
};
export default TrackUserHistory;
